import { FC } from 'react';
import Link from 'next/link';

import { CloudinaryImage } from 'components/common/CloudinaryImage';
import { getTitleFromListing } from 'lib/getTitleFromListing';
import { pageRoutes } from 'lib/routes';
import { Offer } from 'types';
import { formatPrice } from 'utils/text-helpers';

import { LabelValue } from '../LabelValue';

export const OfferModalListingInfoTestIds = {
  container: 'offer-modal-listing-info-container'
};

export type OfferModalListingInfoProps = {
  offer: Offer;
};

const completedImageHeight = 55;

export const OfferModalListingInfo: FC<OfferModalListingInfoProps> = ({ offer }) => {
  const accessoryNames = offer.listing?.accessories?.map(a => a.name);
  const title = getTitleFromListing(offer.listing);

  const hasBox = accessoryNames?.includes('Box');
  const hasPapers = accessoryNames?.includes('Papers / Warranty');

  return (
    <div data-testid={OfferModalListingInfoTestIds.container}>
      <div className='d-flex align-items-center mb-4'>
        <div className='w-100'>
          <div className='text-secondary label text-uppercase mb-1'>Offer</div>
          <div className='riforma-light text-primary fs-18px line-height-24px mb-2'>
            {offer.listing.model.brand.name} {offer.listing.model.name}
          </div>
        </div>
        <div className='mx-auto'>
          <Link href={pageRoutes.listings(offer.listing.id)}>
            <CloudinaryImage
              priority
              alt={`${title} Listing Image`}
              className='border border-muted rounded-1'
              width={completedImageHeight}
              height={completedImageHeight}
              src={offer.listing.images.find(i => i.type === 'FRONT')?.image.optimizedUrl || 'model_placeholder.png'}
            />
          </Link>
        </div>
      </div>
      <hr />
      <div className='d-flex gap-0 gap-md-3 text-secondary w-90 text-uppercase white-space-nowrap'>
        <LabelValue className='px-0' label='Condition' value={offer.listing.condition} />
        <LabelValue label='Box' value={hasBox ? 'Yes' : 'No'} />
        <LabelValue label='Papers' value={hasPapers ? 'Yes' : 'No'} />
        {offer.listing.manufactureYear && <LabelValue label='Year' value={offer.listing.manufactureYear} />}
        <LabelValue label='Listed Price' value={formatPrice(offer.listing.listedPriceCents)} />
      </div>
      <hr />
    </div>
  );
};
